export default __webpack_public_path__ + "9268f88de383a00b323b4b8c0b6408bc.png";